import React from "react";
import PillWithIconFake from "../pill-with-icon-fake/index.js";
import styles from "./styles.js";

const FakeGeneralManagment = () => {
  return (
    <>
      <div className="container">
        <div className="support-fake">
          <div className="support-fake--container">
            <div className="support-fake--container--box-container">
              <PillWithIconFake border />
              <PillWithIconFake border />
              <PillWithIconFake border />
              <PillWithIconFake border />
            </div>
            <div className="skeleton support-fake--footer" />
          </div>
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  );
};

export default FakeGeneralManagment;
